import {
  CREATE_MANUAL_IQ_TEST_QUESTION,
  DELETE_IQ_TEST_QUESTION,
  GET_IQ_TEST_URL,
  GET_ONE_IQ_TEST_QUESTION,
  UPDATE_IQ_TEST_QUESTION,
} from "../apiurls/apiurls";

export const getAllIQTest = async (token, type) => {
  const url = `${GET_IQ_TEST_URL}?test_type=${type}`;

  try {
    const response = await fetch(`${url}`, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const createIQTestQuestion = async (token, payload) => {
  const url = `${CREATE_MANUAL_IQ_TEST_QUESTION}`;

  try {
    const response = await fetch(`${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const getOneIQTest = async (token, id) => {
  const url = `${GET_ONE_IQ_TEST_QUESTION}?id=${id}`;

  try {
    const response = await fetch(`${url}`, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const updateIQTestQuestion = async (token, payload, id) => {
  const url = `${UPDATE_IQ_TEST_QUESTION}?id=${id}`;

  try {
    const response = await fetch(`${url}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const deleteIQTestQuestion = async (token, id) => {
  const url = `${DELETE_IQ_TEST_QUESTION}?id=${id}`;

  try {
    const response = await fetch(`${url}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};
